import axios from "axios";

const URL_BASE = `${process.env.ROOT_API}/cat`;

export default class CatService{
	static async consultar(idUsuario, paginaAtual, catsPorPagina) {
		return axios.get(URL_BASE + "/consultar/" + idUsuario + "?paginaAtual=" + paginaAtual + "&catsPorPagina=" + catsPorPagina);
	}

	static async salvar(idUsuarioResponsavel, form) {
		return axios.post(URL_BASE + "/salvar?idUsuarioResponsavel=" + idUsuarioResponsavel, form);
	}

	static async verificaSeHaCatEnviadoPorUsuario(idUsuario) {
		return axios.get(URL_BASE + "/verificaSeHaCatEnviadoPorUsuario/" + idUsuario);
	}

	static async consultaPorId(id) {
		return axios.get(URL_BASE + "/consultaPorId/" + id);
	}
	static async consultarCat(cpf, cnpj, paginaAtual, catsPorPagina) {
		return axios.get(URL_BASE + "/consultar?paginaAtual=" + paginaAtual + "&catsPorPagina=" + catsPorPagina + "&cpf=" + cpf + "&cnpj=" + cnpj);
	}
	static async baixarArquivosCat(idCat) {
		return axios.get(URL_BASE + "/baixarArquivosCat/" + idCat);
	}
	static async gerarRelatorioDetalhadoCat(idCat) {
		return axios.get(URL_BASE + "/gerarRelatorioDetalhadoCat/" + idCat);
	}
}



// WEBPACK FOOTER //
// ./src/service/CatService.js